"use client"

import { Button, Carousel, Typography, Card, Row, Col } from "antd"
import type { CarouselRef } from "antd/es/carousel"
import { useRef } from "react"
import "./HomePage.css" // Certifique-se de que este arquivo CSS existe
import { LeftOutlined, RightOutlined, CheckCircleOutlined, InfoCircleOutlined, TrophyOutlined } from "@ant-design/icons"

const { Title, Paragraph } = Typography

export default function HomePage() {
  // Referência para o carrossel com o tipo correto importado do Ant Design
  const carouselRef = useRef<CarouselRef>(null)

  // Funções para navegar entre os slides
  const goToPrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev()
    }
  }

  const goToNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next()
    }
  }

  return (
    <>
      <div style={{ paddingTop: "30px" }}></div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: "2rem",
        }}
      >
        <Typography style={{ fontSize: "24px" }}>Bem-vindo à Durafix</Typography>
        <Typography style={{padding: '1rem', }}>Sua solução completa para tintas e produtos de acabamento de alta qualidade.</Typography>
      </div>

      <div className="carousel-container">
        <Carousel autoplay ref={carouselRef}>
          {/* <div>
            <img
              src="/banners/BANNER1.webp"
              style={{
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
              }}
              className="carousel-image produto-imagem"
              alt="Banner 1"
            />
          </div> */}
          <div>
            <img
              src="/banners/BANNER2.webp"
              style={{
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
              }}
              className="carousel-image produto-imagem"
              alt="Banner 2"
            />
          </div>
          <div>
            <img
              src="/banners/BANNER3.webp"
              style={{
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
              }}
              className="carousel-image produto-imagem"
              alt="Banner 3"
            />
          </div>
        </Carousel>

        {/* Botões de navegação */}
        <Button
          className="carousel-arrow prev-arrow"
          icon={<LeftOutlined />}
          onClick={goToPrev}
          aria-label="Slide anterior"
          type="default"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "#fff",
            border: "none",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            transition: "0.3s",
            width: "40px",
            height: "40px",
            borderRadius: "0", // Deixa os cantos quadrados
          }}
        />

        <Button
          className="carousel-arrow next-arrow"
          icon={<RightOutlined />}
          onClick={goToNext}
          aria-label="Próximo slide"
          type="default"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "#fff",
            border: "none",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            transition: "0.3s",
            width: "40px",
            height: "40px",
            borderRadius: "0", // Deixa os cantos quadrados
          }}
        />
      </div>

      {/* Seção dos 3 Cards */}
      <div
        style={{
          padding: "4rem 2rem",
          backgroundColor: "#f5f5f5",
          marginTop: "2rem",
        }}
      >
        <Row gutter={[32, 32]} justify="center">
          <Col xs={24} md={8}>
            <Card
              style={{
                height: "100%",
                textAlign: "center",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
              bodyStyle={{ padding: "2rem 1.5rem" }}
            >
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#1890ff",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 1.5rem auto",
                }}
              >
                <TrophyOutlined style={{ fontSize: "32px", color: "white" }} />
              </div>
              <Title level={4} style={{ marginBottom: "1rem", color: "#333" }}>
                Padrão Durafix de Excelência
              </Title>
              <Paragraph style={{ color: "#666", lineHeight: "1.6" }}>
                Da escolha da matéria-prima ao rigoroso controle de qualidade, cada produto Durafix é desenvolvido para
                entregar performance <strong>superior, durabilidade e o acabamento profissional</strong> que sua obra
                exige. Porque o resultado final importa.
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card
              style={{
                height: "100%",
                textAlign: "center",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
              bodyStyle={{ padding: "2rem 1.5rem" }}
            >
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#1890ff",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 1.5rem auto",
                }}
              >
                <CheckCircleOutlined style={{ fontSize: "32px", color: "white" }} />
              </div>
              <Title level={4} style={{ marginBottom: "1rem", color: "#333" }}>
                Inovação e Soluções Inteligentes
              </Title>
              <Paragraph style={{ color: "#666", lineHeight: "1.6" }}>
                A Durafix investe em tecnologia para oferecer um portfólio completo e versátil. Com nosso{" "}
                <strong>avançado Sistema Tintométrico</strong>, você tem acesso a milhares de cores e infinitas
                possibilidades para dar vida aos seus projetos com a cor exata que imaginou.
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card
              style={{
                height: "100%",
                textAlign: "center",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
              bodyStyle={{ padding: "2rem 1.5rem" }}
            >
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#1890ff",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 1.5rem auto",
                }}
              >
                <InfoCircleOutlined style={{ fontSize: "32px", color: "white" }} />
              </div>
              <Title level={4} style={{ marginBottom: "1rem", color: "#333" }}>
                Compromisso Total com Sua Obra
              </Title>
              <Paragraph style={{ color: "#666", lineHeight: "1.6" }}>
                Acreditamos que <strong>Durafix é muito+obra</strong>. Por isso, oferecemos não apenas produtos de
                ponta, mas também <strong>suporte técnico especializado</strong> e a confiança de uma marca que se
                dedica a entregar soluções completas para o sucesso e a valorização do seu projeto.
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "1rem",
          paddingBottom: "8rem",
          height: "200px",
        }}
      >
        <Typography style={{ fontSize: "24px", marginBottom: "1rem" }}>Qualidade e Confiança</Typography>
        <Typography
          style={{
            paddingLeft: "1rem",
            paddingRight: "1rem",
            textAlign: "center",
            maxWidth: "800px",
          }}
        >
          Na Durafix, combinamos tecnologia avançada e matérias-primas de alta qualidade para oferecer produtos que
          superam as expectativas mais exigentes do mercado.
        </Typography>
        {/* <Link to="/catalogos" style={{ textDecoration: 'none' }}>
                    <Button type="primary" style={{ marginTop: '1rem' }}>
                        Explorar Catálogos
                    </Button>
                </Link> */}
      </div>
    </>
  )
}
